import types from './hubCampaignsTypes';

const initialState = {
    campaignPreview: {},
    campaignList: [],
    pickedCampaign: {},
    socialDataPagination: {
        sortBy: 'id',
        dir: 'DESC',
        page: 1,
        limit: 10,
    },
    salesDataPagination: {
        sortBy: 'id',
        dir: 'DESC',
        page: 1,
        limit: 10,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.SET_CAMPAIGN_PREVIEW: {
            return { ...state, campaignPreview: { ...action.payload } };
        }
        case types.GET_CAMPAIGN_PREVIEW: {
            return { ...state };
        }
        case types.SET_CAMPAIGN_LIST: {
            return { ...state, campaignList: action.payload };
        }
        case types.SET_PICKED_CAMPAIGN: {
            return { ...state, pickedCampaign: action.payload };
        }
        case types.SET_SOCIAL_DATA_PAGINATION: {
            return { ...state, socialDataPagination: action.payload };
        }
        case types.SET_SALES_DATA_PAGINATION: {
            return { ...state, salesDataPagination: action.payload };
        }
        default:
            return state;
    }
};
